import React from 'react'

import { endOfDay, parseISO, startOfDay } from 'date-fns'

function normalize({ strStart, strEnd }) {
  const start = startOfDay(parseISO(strStart))
  const end = endOfDay(parseISO(strEnd))
  return { start, end, strStart, strEnd }
}

export function DateRange({
  start: strStart,
  end: strEnd,
  onStartChange,
  onEndChange
}) {
  const setStart = ({ target: { value: strStart } }) =>
    onStartChange(normalize({ strStart, strEnd }))
  const setEnd = ({ target: { value: strEnd } }) =>
    onEndChange(normalize({ strStart, strEnd }))

  return (
    <div className="flex gh2">
      <input type="date" value={strStart} max={strEnd} onChange={setStart} />
      <input type="date" value={strEnd} min={strStart} onChange={setEnd} />
    </div>
  )
}

export const initDateRange = {
  start: undefined,
  strStart: '',
  end: undefined,
  strEnd: ''
}

export default DateRange
